<template>
  <!-- 后台管理首页 -->
  <div id="splIndex" class="spl-index">
    <!-- 布局头部 -->
    <div class="header">
      <spl-page-header></spl-page-header>
    </div>
    <!-- 布局侧边栏+内容区-->
    <div class="aside-content">
      <!-- 侧边栏 -->
      <div class="aside">
        <ul class="aside-menus">
          <router-link
            tag="li"
            class="aside-menu"
            :to="item.url"
            v-for="(item,index) in asideMenus"
            :key="index"
            active-class="active"
            v-show="item.authority"
          >
            <i class="menu-icon" :class="item.className"></i>
            <span class="menu-name ignore">{{item.menuName}}</span>
          </router-link>
        </ul>
      </div>
      <!-- 内容区 -->
      <div class="content">
        <router-view></router-view>
      </div>
    </div>
  </div>
</template>

<script >
import {
  setSupplierTitleInfo,
  getSupplierBasicInformation,
  getSupplierTitleInfo
} from "common/js/storage";
import Supplier from "models/spl/supplier.js";
const supplier = new Supplier();
// 布局主文件
import SplPageHeader from "components/layout/SplPageHeader";
export default {
  data() {
    return {
      labelLogo:'',
      asideMenus: [
        {
          className: "commodity",
          menuName: "商品",
          url: "/supplier/spl-goods",
          authority: true,
        },
        {
          className: "order",
          menuName: "订单",
          url: "/supplier/spl-order",
          authority: false,
        },
        {
          className: "inventory",
          menuName: "库存",
          url: "/supplier/inventory",
          authority: false,
        },
        {
          className: "marketing",
          menuName: "营销",
          url: "/supplier/spl-bidding",
          authority: false,
        },
        {
          className: "client",
          menuName: "账号",
          url: "/supplier/spl-account",
          authority: true,
        },
      ],
    };
  },
  methods: {   
    // 获取基础信息
    basicInformation() {
      this.labelLogo = getSupplierTitleInfo().labelLogo;
      document.querySelector(
        'title'
      ).innerHTML = getSupplierTitleInfo().mallName;
    },
  },
  watch: {
    labelLogo: function(newvalue, oldvalue) {
      let link = `<link rel="icon" href="${this.labelLogo}">`;
      let tempNode = document.createElement('div');
      tempNode.innerHTML = link;
      document.querySelector('head').append(tempNode.firstChild);
    }
  },
  created() {
    this.basicInformation();
    setTimeout(() => {
      if (getSupplierBasicInformation().moduleSelection === 0&&getSupplierBasicInformation().num == 0) {
        this.asideMenus[1].authority = false
      } else {
        this.asideMenus[1].authority = true
      }
      if (getSupplierBasicInformation().moduleStorage === 0) {
        this.asideMenus[2].authority = false
      } else {
        this.asideMenus[2].authority = true
      }
      if (getSupplierBasicInformation().moduleActivity === 0&&getSupplierBasicInformation().moduleBooth === 0) {
        this.asideMenus[3].authority = false
      } else {
        this.asideMenus[3].authority = true
      }
    },500)
  },
  components: {
    SplPageHeader,
  },
};
</script>

<style lang="scss" scoped>
.spl-index {
  width: 100vw;
  height: 100vh;
  display: flex;
  overflow: hidden;
  flex-direction: column;
  background: skyblue;
  .header {
    width: 100%;
    height: 64px;
    background: salmon;
  }
  .aside-content {
    flex-grow: 1;
    height: 100%;
    width: 100%;
    overflow: hidden;
    display: flex;
    flex-direction: row;
    background: teal;
    .aside {
      min-width: 120px;
      height: 100%;
      background: turquoise;
      .aside-menus {
        width: 100%;
        height: 100%;
        background-color: #233446;
        letter-spacing: 1px;
        .aside-menu {
          cursor: pointer;
          width: 100%;
          height: 40px;
          display: flex;
          flex-direction: row;
          justify-content: center;
          align-items: center;
          .menu-icon {
            width: 32px;
            height: 32px;
            margin-right: 6px;
          }
          .menu-name {
            width: 34px;
            height: 24px;
            line-height: 24px;
            font-size: 16px;
            font-family: "PingFangSC-Regular";
            font-weight: 400;
            color: rgba(255, 255, 255, 1);
          }
          .commodity {
            background-image: url("../../assets/page-aside/commodity@1x.png");
            background-size: cover;
          }
          .order {
            background-image: url("../../assets/page-aside/order@1x.png");
            background-size: cover;
          }
          .inventory {
            background-image: url("../../assets/page-aside/inventory@1x.png");
            background-size: cover;
          }
          .marketing {
            background-image: url("../../assets/page-aside/marketing@1x.png");
            background-size: cover;
          }
          .client {
            background-image: url("../../assets/page-aside/client@1x.png");
            background-size: cover;
          }
        }
        .active {
          background: #3d74f2;
        }
      }
    }
    .content {
      flex-grow: 1;
      height: 100%;
      background: sienna;
    }
  }
}
</style>
<style lang="scss">
.el-button {
  height: 32px;
  line-height: 0px;
  font-size: 14px;
  letter-spacing: 1px;
}
.el-button.btn-text {
  color: rgba(61, 116, 242, 1);
  font-size: 12px;
}
.el-button.btn-text:active {
  color: rgba(61, 116, 242, 1);
  font-size: 12px;
}
.el-button.btn-white {
  border: 1px solid rgba(61, 116, 242, 1);
  background: rgba(255, 255, 255, 1);
  color: #3d74f2;
}
.el-button.btn-white:hover {
  border: 1px solid rgba(61, 116, 242, 0.75);
  background: rgba(61, 116, 242, 0.75);
  color: #fff;
}
.el-button.btn-blue {
  border: 1px solid rgba(61, 116, 242, 1);
  background: rgba(61, 116, 242, 1);
  color: #fff;
}
.el-button.btn-blue:hover {
  background: rgba(55, 103, 214, 1);
  border: 1px solid rgba(55, 103, 214, 1);
  color: #fff;
}
.el-button.disabled {
  border: 0;
  background: #eee;
  color: #aaa;
}
.el-button.disabled:hover {
  border: 0;
  background: #eee;
  color: #aaa;
}
.el-select.gray {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    padding: 0 20px 0 8px;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    padding-left: 15px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-select.white {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
    padding: 0 20px 0 8px;
    font-size: 14px;
    font-family: "PingFangSC-Regular";
    color: rgba(96, 98, 102, 1);
    letter-spacing: 1px;
    padding-left: 15px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-cascader {
  /* width: 300px; */
  height: 32px;
  line-height: 32px;
  .el-input {
    .el-input__inner {
      height: 32px;
      line-height: 32px;
      background: rgba(234, 238, 245, 0.2);
      border: 1px solid #eaeef5;
    }
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
  }
  .is-focus {
    .el-input__inner {
      border: 1px solid rgba(61, 116, 242, 1);
    }
  }
}
.el-input.gray {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.white {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(255, 255, 255, 1);
    border-radius: 4px;
    border: 1px solid rgba(235, 238, 242, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
    right: 0px;
    cursor: pointer;
  }
}
.el-input.disabled {
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    background: rgba(227, 231, 237, 0.5);
    border-radius: 4px;
    border: 1px solid rgba(219, 223, 230, 1);
  }
}
.el-textarea.gray {
  .el-textarea__inner {
    background: rgba(234, 238, 245, 0.2);
    border-radius: 4px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-textarea__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-textarea__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
}
.table-img {
  .el-table {
    font-family: "PingFangSC-Regular";
    border: 1px solid #f2f6fc;
    border-bottom: 0;
    border-radius: 8px 8px 0px 0px;
    .el-table__empty-block {
      background: #fff;
    }
    .el-table__header-wrapper {
      background: #f5f7fa;
      .el-table__header {
        tr {
          th {
            background: #f5f7fa;
            padding: 0;
            .cell {
              color: #606266;
              line-height: 32px;
              height: 32px;
              font-size: 14px;
              letter-spacing: 1px;
              padding: 0 16px;
            }
          }
        }
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          min-height: 54px;
          td {
            min-height: 54px;
            padding: 2px 0px;
            .cell {
              color: #606266;
              /* height: 64px; */
              padding: 5px 16px;
              font-size: 12px;
              /* line-height: 64px; */
              display: flex;
              justify-content: flex-start;
              align-items: center;
              letter-spacing: 1px;
              line-height: 16px;
              font-family: "Microsoft YaHei";
              .img {
                width: 40px;
                min-width: 40px;
                max-width: 40px;
                height: 40px;
                line-height: 40px;
                text-align: center;
                margin-right: 16px;
              }
              .name {
                width: 240px;
                overflow: hidden;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                font-size: 12px;
                line-height: 23px;
                letter-spacing: 0px;
                white-space: pre-wrap;
              }
              .el-button {
                font-size: 12px;
              }
            }
          }
        }
      }
    }
  }
}
.table {
  .el-table {
    font-family: "PingFangSC-Regular";
    border: 1px solid #f2f6fc;
    border-bottom: 0;
    border-radius: 8px 8px 0px 0px;
    .el-table__header-wrapper {
      background: #f5f7fa;
      .el-table__header {
        tr {
          th {
            background: #f5f7fa;
            padding: 0;
            height: 32px;
            .cell {
              color: #606266;
              line-height: 16px;
              padding: 8px 16px;
              font-size: 14px;
            }
          }
        }
      }
    }
    .el-table__body-wrapper {
      .el-table__body {
        tr {
          height: 32px;
          padding: 0;
          td {
            height: 32px;
            padding: 0;
            .cell {
              color: #606266;
              font-size: 14px;
              padding: 0 0 0 16px;
              height: 32px;
              line-height: 32px;
            }
          }
        }
      }
    }
  }
}
.el-date-editor.el-input {
  border: 0;
  .el-input__inner {
    height: 32px;
    line-height: 32px;
    border: 1px solid rgba(234, 238, 245, 1);
  }
  .el-input__inner:hover {
    border-color: rgba(192, 196, 204, 1);
  }
  .el-input__inner:focus {
    border-color: rgba(61, 116, 242, 1);
  }
  .el-input__prefix {
    height: 40px;
    top: -3px;
  }
  .el-input__suffix {
    height: 40px;
    top: -3px;
  }
}
.el-date-editor {
  height: 32px;
  line-height: 32px;
  border: 1px solid rgba(234, 238, 245, 1);
  .el-range-input {
    height: 30px;
    line-height: 30px;
  }
  .el-range-separator {
    line-height: 24px;
  }
  .el-range__icon {
    line-height: 24px;
  }
  .el-input__icon {
    line-height: 24px;
  }
}
.el-form {
  .is-success {
    .el-input__inner:focus {
      border-color: #3d74f2;
    }
  }
  /* .is-error {
    .el-input__inner {
    }
  } */
  .el-form-item {
    margin-bottom: 16px;
    .el-form-item__label {
      line-height: 32px;
      color: #606266;
      padding: 0;
    }
    .el-form-item__content {
      line-height: 32px;
      .el-form-item__error {
        padding-top: 2px;
      }
    }
  }
}
/* el-radio */
.el-radio-group {
  .el-radio-button {
    .el-radio-button__inner {
      padding: 8px 20px;
    }
  }
}
.secondary-menu-container {
  .secondary-menu-title {
    height: 40px;
    line-height: 40px;
    color: rgba(48, 49, 51, 1);
    font-weight: 500;
    letter-spacing: 1px;
    width: 120px;
    text-align: center;
  }
}
.el-dialog {
  border-radius: 4px;
  .el-dialog__header {
    padding: 0 24px;
    line-height: 48px;
    color: #606266;
    font-family: "PingFangSC-Medium";
    letter-spacing: 1px;
    .el-dialog__title {
      font-size: 16px;
      color: #606266;
      font-weight: 500;
    }
    .el-dialog__headerbtn {
      top: 15px;
    }
  }
  .el-dialog__body {
    padding: 0px 16px 16px 16px;
    .border {
      border-bottom: 1px solid #f7f7f7;
      margin-bottom: 16px;
    }
    .el-form {
      .el-form-item {
        margin-bottom: 24px;
      }
      .el-form-item:last-child {
        margin-bottom: 0;
      }
    }
  }
}
</style>
